import React, { memo } from "react";

import { validators, formats } from "investira.sdk";
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  Icon,
  Typography,
  IconButton,
  Stack,
  useMediaQuery,
  Card,
} from "investira.react.components";
import CorrelacaoAtivos from "./CorrelacaoAtivos";

const CorrelacaoDialog = memo((props) => {
  const {
    infos,
    ativos,
    benchmarks,
    correlacoes,
    onSetAtivos,
    onSetCorrelacoes,
  } = props;

  const isUpMd = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const xDialogProps = isUpMd
    ? {
        fullScreen: true,
        maxWidth: "xl",
      }
    : {
        fullScreen: true,
        PaperProps: {
          sx: {
            margin: 0,
          },
        },
      };

  const isOpen = !validators.isEmpty(correlacoes);

  if (!isOpen) {
    return null;
  }

  function handleClose() {
    onSetAtivos({});
    onSetCorrelacoes(null);
  }

  return (
    <>
      <Dialog
        fullScreen
        open={isOpen}
        onClose={() => handleClose({})}
        {...xDialogProps}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ flexGrow: 1 }} variant="h6" component="div">
              Correlação | {infos.cenario.cenario} - {infos.mercado}
            </Typography>
            <IconButton
              edge="end"
              color="primary"
              onClick={() => handleClose({})}
              aria-label="close"
            >
              <Icon iconName="cancel" size={21} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ display: "flex", px: 3 }}>
          <Stack flexGrow={1} mt={2} sx={{ width: "100%" }}>
            <Stack
              sx={{ gap: 2 }}
              component="section"
              direction={{ xs: "column", md: "row" }}
              pb={2}
            >
              {infos.maior_correlacao && (
                <Card
                  variant="outlined"
                  sx={{
                    display: "flex",
                    flexGrow: 1,
                  }}
                >
                  <Stack
                    px={2}
                    py={2}
                    flexGrow={1}
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontWeight: 500 }}
                    >
                      Maior Correlação
                    </Typography>
                    <Stack direction="column" justifyContent="flex-end">
                      <Stack>
                        <Typography variant="h5" color={"textPrimary"}>
                          <b>{infos.maior_correlacao}</b>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Card>
              )}

              <Card
                variant="outlined"
                sx={{
                  display: "flex",
                  flexGrow: 1,
                }}
              >
                <Stack
                  px={2}
                  py={2}
                  flexGrow={1}
                  justifyContent="space-between"
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                  >
                    Impacto Total (%)
                  </Typography>
                  <Stack direction="column" justifyContent="flex-end">
                    <Stack>
                      <Typography variant="h5" color={"textPrimary"}>
                        <b>
                          {infos.impacto_percentual_total &&
                            formats.formatNumber(
                              infos.impacto_percentual_total,
                              2,
                              true
                            )}
                        </b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Card>

              <Card
                variant="outlined"
                sx={{
                  display: "flex",
                  flexGrow: 1,
                }}
              >
                <Stack
                  px={2}
                  py={2}
                  flexGrow={1}
                  justifyContent="space-between"
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                  >
                    Impacto Total (R$)
                  </Typography>
                  <Stack direction="column" justifyContent="flex-end">
                    <Stack>
                      <Typography variant="h5" color={"textPrimary"}>
                        <b>
                          {infos.impacto_financeiro_total &&
                            formats.formatNumber(
                              infos.impacto_financeiro_total,
                              2,
                              true
                            )}
                        </b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Card>
            </Stack>
            <CorrelacaoAtivos
              ativos={ativos}
              benchmarks={benchmarks}
              correlacoes={correlacoes}
              cenarioId={infos.cenario.cenario_id}
            />
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
});

export default CorrelacaoDialog;
